// extracted by mini-css-extract-plugin
export var profilePicture = "profilePicture-module--profilePicture--tkpBk";